// frontend/src/pages/AssetsPage.tsx
import React, { useState, useEffect, useCallback } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import { AssetForm } from '../components/forms/AssetForm'; // Importar el formulario

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

interface Asset {
  id: number;
  name: string;
  identifier: string;
  category: string | null;
  status: string | null;
  last_maintenance_date: string | null;
}

export function AssetsPage() {
  const [assets, setAssets] = useState<Asset[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Función para cargar los activos
  const fetchAssets = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_BASE_URL}/api/data/assets`);
      if (!response.ok) {
        throw new Error('Error al obtener los activos.');
      }
      const data: Asset[] = await response.json();
      setAssets(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error desconocido');
      console.error("Error fetching assets:", err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Cargar activos cuando el componente se monta
  useEffect(() => {
    fetchAssets();
  }, [fetchAssets]); // fetchAssets está envuelta en useCallback

  return (
    <Container fluid className="mt-3">
      <Row>
        {/* Columna para la tabla de activos */}
        <Col md={8} className="mb-3">
          <h3>Activos Registrados</h3>
          {isLoading && <p>Cargando activos...</p>}
          {error && <Alert variant="danger">{error}</Alert>}
          {!isLoading && !error && (
            <Table striped bordered hover responsive size="sm">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>Identificador</th>
                  <th>Categoría</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {assets.length > 0 ? (
                  assets.map(asset => (
                    <tr key={asset.id}>
                      <td>{asset.id}</td>
                      <td>{asset.name}</td>
                      <td>{asset.identifier}</td>
                      <td>{asset.category || '-'}</td>
                      <td>{asset.status || '-'}</td>
                      {/* Podrías añadir un botón de ver detalles/editar aquí en el futuro */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center">No hay activos registrados.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Col>

        {/* Columna para el formulario de nuevo activo */}
        <Col md={4}>
          {/* Pasamos fetchAssets como callback para que se refresque la lista al crear */}
          <AssetForm onAssetCreated={fetchAssets} />
        </Col>
      </Row>
    </Container>
  );
}